//authentication
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";

//get last matches
export const LAST_MATCHES_START="LAST_MATCHES_START";
export const LAST_MATCHES_SUCCESS="LAST_MATCHES_SUCCESS";
export const LAST_MATCHES_FAIL="LAST_MATCHES_FAIL";

//leagues
export const SELECT_LEAGUES="SELECT_LEAGUES";